import { Feature } from '@sdk/common/features';

const getPremiumTooltipId = (premiumFeature: Feature, id = ''): string =>
  `tooltip-${premiumFeature}-${id}`;

export default getPremiumTooltipId;
